import AutopayGoogleReview from '../../../assets/autopay-google-review.svg';
import RateGeniusGoogleReview from '../../../assets/rategenius-google-review.svg';
import TreslGoogleReview from '../../../assets/tresl-google-review.svg';

export const reviewsAssetByBrand: Record<string, string> = {
  AUTOPAY: AutopayGoogleReview,
  RateGenius: RateGeniusGoogleReview,
  Tresl: TreslGoogleReview,
};

export const reviewsUrlByBrand: Record<string, string> = {
  AUTOPAY: 'https://share.google/AJbuprGa55a5LBdn8',
  RateGenius: 'https://share.google/W3kuYmAiEbNlzM3Ft',
  Tresl: 'https://share.google/qaLLhWY3zf7ZENOOw',
};
